import React from 'react';
import { Col, Form, InputNumber, Row } from 'antd';

import { Text } from '@/components/Typography';
import { getDecimalSeparator } from '@/utils/getDecimalSeparator';

interface DependentNumberFieldProps {
	label: string;
	placeholder: string;
	name: (string | number)[];
	span?: number;
	xs?: number;
	xxl?: number;
}

export function DependentNumberField({
	label,
	placeholder,
	name,
	span = 24,
	xs,
	xxl
}: Readonly<DependentNumberFieldProps>): JSX.Element {
	return (
		<Row gutter={[0, 5]}>
			<Col span={24}>
				<Text strong>{label}</Text>
			</Col>
			<Col span={span} xs={xs} xxl={xxl}>
				<Form.Item style={{ margin: 0 }} name={name}>
					<InputNumber
						min={0}
						style={{ width: '100%' }}
						placeholder={placeholder}
						decimalSeparator={getDecimalSeparator()}
					/>
				</Form.Item>
			</Col>
		</Row>
	);
}
